export enum EstimateStatusKeyEnum {
    Draft = 'draft',
    Sent = 'sent',
    Accepted = 'accepted',
    Rejected = 'rejected',
    Canceled = 'canceled',
}